/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_Caption_GeneratedInputs */

const cs_social_export_caption_generated = /** @type {(inputs: Social_Export_Caption_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popisek vygenerován.`)
};

const en_social_export_caption_generated = /** @type {(inputs: Social_Export_Caption_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caption generated.`)
};

/**
* | output |
* | --- |
* | "Caption generated." |
*
* @param {Social_Export_Caption_GeneratedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_caption_generated = /** @type {((inputs?: Social_Export_Caption_GeneratedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_Caption_GeneratedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_caption_generated(inputs)
	return cs_social_export_caption_generated(inputs)
});